import React, { Component } from 'react';
import { array, bool } from 'prop-types'
import { createComponent, withTheme, ThemeProvider } from '@ycos/fela';
import { Grid } from '@ycos/component-grid';

const ThreeColumnItemListWrapper = createComponent('div', () => ({
    display: 'block',
    'screen-medium': {
      display: 'flex',
      flexWrap: 'wrap'
    }
}));

const ItemColumn = createComponent('div', ({ theme }) => {
  const mediumGutter = 2 * theme.spacingMultiplier;
  const largeGutter = 3 * theme.spacingMultiplier;

  return {
    display: 'inline-block',
    width: '100%',
    paddingTop: `${6 * theme.spacingMultiplier}px`,
    'screen-medium': {
      width: `calc(33.3% - ${mediumGutter * 2/3}px)`,
      marginRight: mediumGutter,
      ':nth-child(3n)': {
        marginRight: 0
      }
    },
    'screen-large': {
      width: `calc(33.3% - ${largeGutter * 2/3}px)`,
      marginRight: largeGutter
    }
  }
});

class ThreeColumnItemList extends Component {
  static layoutVariant = ['isc-3-column-item-list'];

  render() {
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];

    return (
      <ThemeProvider theme={{...this.props.theme, direction: 'ltr'}}>
        <Grid.Row verticallyCenter={this.props.verticallyCenter}>
          <Grid.Span small={{ offset: 0, width: 6 }} medium={{ offset: 1, width: 10 }}>
            <ThreeColumnItemListWrapper>
              {children.map(child =>
                <Grid.GridContext medium={{ width: 3 }} key={child.key}>
                  <ItemColumn>
                    <ThemeProvider theme={this.props.theme}>
                      {child}
                    </ThemeProvider>
                  </ItemColumn>
                </Grid.GridContext>)}
            </ThreeColumnItemListWrapper>
          </Grid.Span>
        </Grid.Row>
      </ThemeProvider>
    );
  }
}

ThreeColumnItemList.propTypes = {
  children: array,
  verticallyCenter: bool
};

ThreeColumnItemList.defaultProps = {
  children: []
};

export default withTheme(ThreeColumnItemList);
